module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"to":"To:","newContact":"Add new contact","noNumber":"No phone number","noResults":"No contacts found that match the search: \\"{query}\\".","sendMessageTo":"Send message to:","placeholder":"Type a name or phone number..."}}')
  delete Component.options._Ctor
}
